import { evaluateMathOperation } from '../../lib/utils';
import MatrixLookup from './MatrixLookup';

/// evaluate given condition records
const EvaluateCondition = (conditionRecords, answers, matrixData, configGroup, qty, isVal, flipSign) => {
    if(flipSign === undefined)
        flipSign= false;
    answers["IV_CONFIG_GRP"] = configGroup;
    answers["IV_CONFIG_GRP2"] = configGroup;
    answers["QTY_ORDERED"] = qty.toString();

    answers["BUSINESS_UNIT_IN"] = answers["BUSINESS_UNIT_IN"].replace("002-","");
    // Note: This component, being called conditionally, should not use hooks
    // like useState and useContext etc. to maintain react hooks order. 
    if (conditionRecords === null || conditionRecords === undefined || conditionRecords.length === 0)
    {
        
        return false;
        //throw new Error('No conditions given for evaluation');

    }
     
    for(let i=0;i< conditionRecords.length; i++){
      
        let { conditionName, conditionVariable, conditionAnswer, conditionCompOperator, matrix, matrixAnswer } = conditionRecords[i];
          //if(conditionName === "CND_PP_MTO")
          if(conditionName ==="ALWAYS_TRUE")
            conditionRecords[i]["Result"] = true;
          else{
            
        
            const leftOperand =
                matrix === true
                ? MatrixLookup(conditionVariable, answers, matrixData, isVal, 0)
                : (conditionVariable === "1" ? "1" : answers[conditionVariable]);

            const rightOperand = 
                matrixAnswer === true 
                ? MatrixLookup(conditionAnswer, answers, matrixData, isVal, 0)
                : (conditionAnswer === "1" ? "1" : (answers[conditionAnswer] ?? conditionAnswer));
            
                conditionRecords[i]["Result"] = (
                    (typeof leftOperand !== "undefined" && typeof rightOperand === "undefined" && conditionCompOperator === "<>")
                    ||
                    (typeof leftOperand === "undefined" && typeof rightOperand !== "undefined" && conditionCompOperator === "<>")
                    ||
                    // Handle = operator for undefined/empty comparisons
                    (typeof leftOperand === "undefined" && rightOperand === "" && conditionCompOperator === "=")
                    ||
                    (leftOperand === "" && typeof rightOperand === "undefined" && conditionCompOperator === "=")
                    ||
                    (typeof leftOperand === "undefined" && typeof rightOperand === "undefined" && conditionCompOperator === "=")
                    ||
                    ((typeof leftOperand !== "undefined" && typeof rightOperand !== "undefined") 
                        &&
                        evaluateMathOperation(
                            leftOperand,
                            rightOperand,
                            conditionCompOperator,
                            isVal,
                            0,
                            flipSign
                        ))
                );
            //if(conditionName==="CND_SA637_STK") 
          //save me
        }
    }
    
  

    // Start with the result of the first object
    let result = conditionRecords[0].Result;
    
        const conditionGroups = [];
        let currentGroup = [];
        
        for (let i = 0; i < conditionRecords.length; i++) {
            // Add the current condition to the current group
            currentGroup.push(conditionRecords[i]);
            
            // If this condition has an OR operator, complete the current group
            // and start a new group for the next condition
            if (conditionRecords[i].conditionOperator === "OR") {
                conditionGroups.push([...currentGroup]);
                currentGroup = []; // Start a new group
            } 
            // If it's the last condition, add the current group
            else if (i === conditionRecords.length - 1) {
                conditionGroups.push([...currentGroup]);
            }
        }
        // Handle empty array edge case
        if (conditionGroups.length === 0 && currentGroup.length > 0) {
            conditionGroups.push(currentGroup);
        }
        


    // Evaluate each group (AND operations within groups)
        const groupResults = conditionGroups.map(group => {
        // Start with the first condition's result
        let groupResult = group[0].Result;
        
        // Combine with the rest using AND logic
        for (let i = 0; i < group.length - 1; i++) {
            // Only consider conditions joined by AND
            if (group[i].conditionOperator === "AND") {
                groupResult = groupResult && group[i + 1].Result;
            }
        }
        return groupResult;
});

// Combine all group results with OR logic
result = groupResults[0];
for (let i = 1; i < groupResults.length; i++) {
    result = result || groupResults[i];
}

return result;
        
    
};

export default EvaluateCondition;
